import React from 'react'
import PropTypes from 'prop-types'
import 'cleave.js/dist/addons/cleave-phone.id'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import './LeadForm.sass'

class LeadForm extends React.PureComponent {
  render = () => {
    const { isModalOpen, toggle } = this.props

    return (
      <Modal isOpen={isModalOpen} toggle={toggle} className="USP--Modal">
        <ModalHeader toggle={toggle}>
          Lindungi Kendaraan Anda Sekarang!
        </ModalHeader>
      </Modal>
    )
  }
}

LeadForm.propTypes = {
  isModalOpen: PropTypes.bool,
  toggle: PropTypes.func
}

export default LeadForm
